const normalizeRole = (user) => String(user?.role_name || user?.role || "")
    .trim().toLowerCase().replaceAll("_", " ").replaceAll("-", " ");

export function canManageTaskDeletion(user) {
    if (!user) return false;
    const role = normalizeRole(user);
    return role === "owner";
}
